import { ChangeEvent, Dispatch, SetStateAction, useCallback } from 'react'
import {
  filterBreadsByCategory,
  filterBreadsByCurrentTab,
  filterBreadsByKeyword,
  filterBreadsByScheduleOrStocks,
  filterBreadsByStatus,
  filterBreadsByStocks,
  filterBreadsByType,
} from 'lib/filter'
import { BreadType } from 'types/bread'
import { CategoryType } from 'types/category'
import { StockType, StockUnionType } from 'types/stock'
import { ScheduleType } from 'types/schedule'
import { DayOfWeekType } from 'lib/daysOfWeek'

type UseHandleCheckedOrderTypesParams = {
  breads: BreadType[]
  categories: CategoryType[]
  categoryName: string
  setBreadList: Dispatch<SetStateAction<BreadType[]>>
  setCheckedOrderTypes: Dispatch<SetStateAction<string[]>>
  isShownPrivate: boolean
  keyword: string
  stocks?: StockType[]
  schedules?: ScheduleType[]
  isFuture?: boolean
  dayOfWeek?: DayOfWeekType
  isTemporaryClose?: boolean
  currentTab?: 'released' | 'unreleased'
}

const useHandleCheckedOrderTypes = (params: UseHandleCheckedOrderTypesParams) => {
  const {
    breads,
    categories,
    categoryName,
    setBreadList,
    setCheckedOrderTypes,
    isShownPrivate,
    keyword,
    stocks,
    schedules,
    isFuture,
    dayOfWeek,
    isTemporaryClose,
    currentTab,
  } = params

  return useCallback(
    (id: string) => {
      setCheckedOrderTypes((prevState) => {
        let nextState: string[] = []
        // 選択済みの値であれば削除
        if (prevState.some((state) => state === id)) {
          nextState = prevState.filter((state) => state !== id)
        } else {
          nextState = [...prevState, id]
        }
        // フィルタリング
        let _breads = breads
        _breads = filterBreadsByStatus(_breads, isShownPrivate)
        _breads = filterBreadsByCategory(categoryName, categories, _breads)
        _breads = filterBreadsByKeyword(keyword, _breads)
        if (stocks && schedules && dayOfWeek && currentTab) {
          _breads = filterBreadsByCurrentTab({
            breads: _breads,
            checkedOrderTypes: nextState,
            currentTab,
            dayOfWeek,
            stocks,
            schedules,
          })
        }
        setBreadList([..._breads])
        return [...nextState]
      })
    },
    [
      breads,
      categories,
      categoryName,
      setBreadList,
      setCheckedOrderTypes,
      isShownPrivate,
      stocks,
      schedules,
      isFuture,
      dayOfWeek,
      isTemporaryClose,
      keyword,
      currentTab,
    ]
  )
}

export default useHandleCheckedOrderTypes
